import { ImageViewerImage } from "@omni/types/api/product/bff/shared/imageViewerImage.model";
import { ImageViewerVideo } from "@omni/types/api/product/bff/shared/imageViewerVideo.model";
import { cn } from "@omni/utils/styles";

import { RouterModal } from "@/components/General/Modal/routerModal";
import { ImageViewerFullWidth } from "@/components/Product/ImageViewerFullWidth/imageViewerFullWidth.container";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type Props = {
    title?: string;
    images: Array<ImageViewerImage>;
    videos: Array<ImageViewerVideo>;
    defaultVideoThumbnailPath?: string;
    className?: string;
};

export const ImageViewerModal = ({
    title,
    images,
    videos,
    defaultVideoThumbnailPath,
    className
}: Props) => {
    const { t } = useGranite();

    return (
        <RouterModal
            className={cn(className)}
            modalType={ModalType.ImageViewer}
            withFooter={false}
            size={"xl"}
            sheetDetent={"default"}
            title={title || t("modal.image-viewer.title")}
        >
            <ImageViewerFullWidth
                className={cn("tw:overflow-hidden tw:w-full")}
                images={images}
                videos={videos}
                defaultVideoThumbnailPath={defaultVideoThumbnailPath}
            />
        </RouterModal>
    );
};
